import get from 'lodash/get';

function convertCurrencyIfNumber(value) {
  if (typeof value !== 'number') {
    return value;
  }
  return value / 100;
}

export const generateAccount = (account, balanceSellingAccount) => ({
  username: account.value,
  imap_username: account.imap_username,
  password: account.password,
  totp_secret: account.twoFactorCode || '',
  payment_info: {
    use_gift: true,
  },
  billing_address: {
    first_name: get(balanceSellingAccount, 'billing_address.first_name', ''),
    last_name: get(balanceSellingAccount, 'billing_address.last_name'),
    address_line1: get(balanceSellingAccount, 'billing_address.address_line1', ''),
    address_line2: get(balanceSellingAccount, 'billing_address.address_line2'),
    city: get(balanceSellingAccount, 'billing_address.city', ''),
    state: get(balanceSellingAccount, 'billing_address.state', ''),
    zip_code: get(balanceSellingAccount, 'billing_address.zip_code', ''),
    country: get(balanceSellingAccount, 'billing_address.country', 'US'),
    phone_number: get(balanceSellingAccount, 'billing_address.phone_number', ''),
  },
  pause_on_deprime: get(balanceSellingAccount, 'account_locked', true),
  account_locked: get(balanceSellingAccount, 'account_locked', false),
  check_gift_balance: get(balanceSellingAccount, 'check_gift_balance', true),
  enable_jit_gc: get(balanceSellingAccount, 'enable_jit_gc', false),
  active: get(balanceSellingAccount, 'active', false),
  affiliate_url: get(balanceSellingAccount, 'affiliate_url', ''),
  notes: get(balanceSellingAccount, 'notes', ''),

  max_orders_per_day: get(balanceSellingAccount, 'max_orders_per_day', 3),
  max_spend_per_day: get(balanceSellingAccount, 'max_spend_per_day', 10000) / 100,
  min_order_value: get(balanceSellingAccount, 'min_order_value', 0) / 100,
  max_order_value: get(balanceSellingAccount, 'max_order_value', 9000) / 100,

  max_spend_unshipped: convertCurrencyIfNumber(get(balanceSellingAccount, 'max_spend_unshipped', 200000)),
  max_spend_lifetime: convertCurrencyIfNumber(get(balanceSellingAccount, 'max_spend_lifetime', 10000000)),
  proxy_url: get(balanceSellingAccount, 'proxy_url', ''),
  max_orders_lifetime: get(balanceSellingAccount, 'max_orders_lifetime', 10000),
  ordering_days: get(balanceSellingAccount, 'ordering_days', ''),
  order_gap: get(balanceSellingAccount, 'order_gap', 6),
  max_orders_unshipped: get(balanceSellingAccount, 'max_orders_unshipped', 20),

  affiliate_max_orders_per_day: get(balanceSellingAccount, 'affiliate_max_orders_per_day', null),
  tax_exempt_states: get(balanceSellingAccount, 'tax_exempt_states', []),
  only_ship_to_states: get(balanceSellingAccount, 'only_ship_to_states', []),
  stealth_group_id: get(balanceSellingAccount, 'stealth_group_id', ''),
  tags: get(balanceSellingAccount, 'tags', []),
  pause_on_error_codes: get(balanceSellingAccount, 'pause_on_error_codes', [
    'invalid_login_credentials',
    'account_locked_verification_required',
    'login_attempt_blocked',
    'account_locked',
    'insufficient_gift_balance',
    'payment_info_problem',
    'billing_address_refused',
    'invalid_payment_method',
    'invalid_card_number'
  ]),
  source: get(balanceSellingAccount, 'source', 'amazon'),
  imap_enabled: get(balanceSellingAccount, 'imap_enabled', false),
});



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Data/LinkedAccountModal/LinkedAccount.util.js